import { Box, Rating, Typography, useTheme } from '@mui/material'
import { useParams } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import React, { useCallback, useEffect } from 'react'

import { useOnlineSessionsStore } from '../../../store/onlinesessions.store'
import TryAgainMessageBlock from '../../common/TryAgainMessageBlock'
import { Icons } from '../../../utils/utilities'

const feedbackLabelsAndDetails = {
    "videoStable": { type: "yesorno", label: "Did you experience stable video feeds?" },
    "vitualboardStable": { type: "yesorno", label: "Did you experience smooth virtual board?" },
    "audioStable": { type: "yesorno", label: "Did you experience stable audio feeds?" },
    "ableToCreatePoll": { type: "yesorno", label: "Experienced good poll sessions?" },
    "remark": { type: "text", label: "Remarks" },
}

const OnlineSessionFeedbacksDetails = observer( () => {

    const { palette, border, layout } = useTheme()
    const { meeting_id } = useParams()

    const OnlineSessionsStore = useOnlineSessionsStore()

    const meetingFeedbacks = OnlineSessionsStore.getFeedbacks
    const error = OnlineSessionsStore.getErrors.onlineSessionFeedbacks

    const { refreshing } = OnlineSessionsStore.getFeedbacksLoadingStatus


    const fetchMeetingFeedbacks = useCallback( async () => {
        OnlineSessionsStore.fetchOnlineSessionFeedbacks( meeting_id )
    }, [meeting_id, OnlineSessionsStore] )

    useEffect( () => {
        fetchMeetingFeedbacks()
    }, [fetchMeetingFeedbacks] )

    return (
        <Box padding="10px">
            <Box marginTop="10px" display="flex" flexWrap="wrap" gap="10px">
                <Typography variant="h6" fontWeight="600" component="h4" fontSize="14px">Overall Rating</Typography>
                {!error && meetingFeedbacks.length > 0 && <Box display="flex" gap="10px" alignItems="center">
                    <Rating readOnly size='small' value={( meetingFeedbacks.reduce( ( acc, data ) => acc + ( data?.feedback?.overallExperience || 0 ), 0 ) / meetingFeedbacks.length ).toFixed( 1 ) || 0} />
                    <Typography fontSize="12px" component="em">({( meetingFeedbacks.reduce( ( acc, data ) => acc + ( data?.feedback?.overallExperience || 0 ), 0 ) / meetingFeedbacks.length ).toFixed( 1 )})</Typography>
                </Box>}
            </Box>
            {!error && meetingFeedbacks.length > 0 && <Box maxHeight="350px" overflow="auto" className="custom-scrollbar" marginTop="20px" >
                <Box display="flex" flexDirection="column" gap="10px" flexWrap='wrap'>
                    {meetingFeedbacks?.map( ( feedback, index ) => (
                        <Box sx={{ cursor: "pointer", ":hover": { borderStyle: "dashed" } }} width="100%" border={border[1]} padding="10px" borderRadius="5px" key={index}>
                            <Box marginBottom="10px" variant="h6" display="flex" flexWrap="wrap" gap="10px" >
                                <Typography fontWeight="600" component="h5" fontSize="14px">
                                    {feedback.user_details?.name || feedback.user_id}
                                </Typography>
                                <Box display="flex" gap="10px" alignItems="center">
                                    <Rating readOnly size='small' value={feedback.feedback["overallExperience"] || 0} />
                                    <Typography fontSize="12px" component="em">({feedback.feedback["overallExperience"]})</Typography>
                                </Box>

                            </Box>
                            <Box display="flex" gap="10px" alignItems="center" flexWrap="wrap">
                                {Object.keys( feedback.feedback ).map( key => {
                                    if ( feedbackLabelsAndDetails[key]?.type === "yesorno" )
                                        return (
                                            <Box padding="5px" bgcolor={palette.contentBg} borderRadius="5px" border={border[1]} display="flex" key={key} gap="10px" alignItems="center" >
                                                <Box marginBottom="10px" fontSize="24px" color={feedback.feedback[key] === "Yes" ? palette.success.main : palette.error.main} component="span">
                                                    {feedback.feedback[key] === "Yes" ? Icons.default.CheckCircleIcon : feedback.feedback[key] === "No" ? Icons.default.ErrorIcon : Icons.default.DoNotDisturb}
                                                </Box>
                                                <Box>
                                                    <Typography fontSize="12px" component="p" fontStyle="italic">{feedbackLabelsAndDetails[key].label}</Typography>
                                                    <Typography fontSize="12px" component="p" fontWeight="500">{feedback.feedback[key]}</Typography>
                                                </Box>
                                            </Box>
                                        )
                                    else if ( feedbackLabelsAndDetails[key]?.type === "rating" )
                                        return (
                                            <Box padding="5px" borderRadius="20px" bgcolor={palette.contentBg} key={key} gap="10px"  >
                                                <Box>
                                                    <Typography fontSize="12px" component="p">{feedbackLabelsAndDetails[key].label}</Typography>
                                                </Box>
                                                <Box display="flex" gap="10px" alignItems="center">
                                                    <Rating readOnly size='small' value={feedback.feedback[key] || 0} />
                                                    <Typography fontSize="12px" component="em">({feedback.feedback[key]})</Typography>
                                                </Box>
                                            </Box>
                                        )
                                    else if ( feedbackLabelsAndDetails[key]?.type === "text" && feedback.feedback[key] )
                                        return (
                                            <Box padding="5px" borderRadius="20px" bgcolor={palette.contentBg} key={key} gap="10px"  >
                                                <Box>
                                                    <Typography fontSize="12px" component="p">{feedbackLabelsAndDetails[key].label}</Typography>
                                                </Box>
                                                <Box display="flex" gap="10px" alignItems="center">
                                                    <Typography fontSize="12px" component="em">{feedback.feedback[key]}  </Typography>
                                                </Box>
                                            </Box>
                                        )
                                    else
                                        return null
                                } )}
                            </Box>
                        </Box>
                    ) )}
                </Box>
            </Box>}
            {!error && meetingFeedbacks.length === 0 && <Box bgcolor={palette.contentBg} padding="20px" borderRadius={layout.borderRadius} >
                <Typography variant='subtitle2' component="p" textAlign="center">No feedbacks received.</Typography>
            </Box>}
            {error && <TryAgainMessageBlock parent='component' getData={fetchMeetingFeedbacks} loading={refreshing} code={error.code} err={error.message} />}
        </Box>
    )
} )

export default OnlineSessionFeedbacksDetails
